const withAnimation = true;
const duration = 100; /*ms */
const easing = "ease-in";

class AccordionV2 {
   // const duration = 300;

   constructor(c) {
    // Store the .accordion-details element
    this.parent = c.parent
    // Store the .accordion-summary element
    this.summary = this.parent.querySelector(".accordion-summary");
    // Store the <div class="content"> element
    this.content = this.parent.querySelector(".accordion-summary + *");

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    this.summary?.setAttribute('aria-expanded', false)
    // Detect user clicks on the summary element
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.parent.style.overflow = "hidden";
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.parent.open) {
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.parent.open) {
      this.shrink();
    }
    
    
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;
	
	  this.content.classList.add('d-none')
	  this.content.classList.remove('d-flex')

    this.summary.setAttribute('aria-expanded', false)

    // Store the current height of the element
    const startHeight = `${this.parent.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
	
	this.parent.querySelector(".plus").classList.remove('d-none');
    this.parent.querySelector(".minus").classList.add('d-none')

    // Start a WAAPI animation
    this.animation = this.parent.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      },
      {
        duration,
        easing
      }
    );

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
	
    this.parent.style.height = `${this.parent.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.parent.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
	
	this.parent.querySelector(".plus").classList.add('d-none');
  this.parent.querySelector(".minus").classList.remove('d-none')
	
	  this.content.classList.remove('d-none')
	  this.content.classList.add('d-flex')

    // collapse other elements
    this.collapse();
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
	
	  this.content.classList.remove('d-none')
	  this.content.classList.add('d-flex')
	  
	  this.parent.querySelector(".plus").classList.add('d-none');
    this.parent.querySelector(".minus").classList.remove('d-none')
    
    this.summary.setAttribute('aria-expanded', true)
	  
    // Get the current fixed height of the element
    const startHeight = `${this.parent.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.parent.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      },
      {
        duration,
        easing
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.parent.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.parent.style.height = this.parent.style.overflow = "";
  }

   collapse() {
      let accordionv2 = document.querySelectorAll('.accordion-details');
      if (accordionv2?.length > 1) {
        for (let i = 0; i < accordionv2.length; i++) {
            let enableCollapse = accordionv2[i].getAttribute('data-enable-collapse');
            this.allContent = accordionv2[i].querySelector(".accordion-summary + *");
            if((this.allContent.id !== this.content.id) && enableCollapse) {
              this.allContent.classList.add("d-none");
              this.allContent.classList.remove("d-flex");
              accordionv2[i].querySelector(".minus").classList.add('d-none');
              accordionv2[i].querySelector(".plus").classList.remove('d-none');
              accordionv2[i].open = false;
            } 
            this.isClosing = false;
            this.isExpanding = false;
        }
        
      };
   }

}

try {
let accordionv2 = document.querySelectorAll('.accordion-details')
if (accordionv2.length > 0) {
    for (let i = 0; i < accordionv2.length; i++) {
     new AccordionV2({
            parent: accordionv2[i]
        })
    }
}
}
catch (e) {
  console.log(e)
}